import React, { useState } from 'react';
import { Shield, Users, MapPin, Clock, Star, Headphones } from 'lucide-react';
import CallbackModal from './CallbackModal';
import './Features.css';

const Features = () => {
  const [isCallbackModalOpen, setIsCallbackModalOpen] = useState(false);

  const handleSpeakToExpertClick = () => {
    setIsCallbackModalOpen(true);
  };

  const features = [
    {
      icon: <Shield size={48} />,
      title: 'Safe & Secure',
      description: 'Your safety is our priority. All tours are vetted and insured with 24/7 support.'
    },
    {
      icon: <Users size={48} />,
      title: 'Expert Local Guides',
      description: 'Connect with knowledgeable local guides who know the hidden gems of each destination.'
    },
    {
      icon: <MapPin size={48} />,
      title: 'Personalized Itineraries',
      description: 'AI-powered recommendations tailored to your interests, budget, and travel style.'
    },
    {
      icon: <Clock size={48} />,
      title: 'Flexible Scheduling',
      description: 'Choose your own dates and customize your itinerary to fit your schedule perfectly.'
    },
    {
      icon: <Star size={48} />,
      title: 'Authentic Experiences',
      description: 'Discover local culture, cuisine, and traditions through carefully curated experiences.'
    },
    {
      icon: <Headphones size={48} />,
      title: '24/7 Support',
      description: 'Round-the-clock customer support to help you before, during, and after your trip.'
    }
  ];

  return (
    <section className="section features">
      <div className="container">
        <h2 className="section-title">Why Choose TravelCompanion?</h2>
        <p className="section-subtitle">
          We make travel planning effortless with our innovative platform and expert local knowledge
        </p>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="stats-section">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">50K+</div>
              <div className="stat-label">Happy Travelers</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">25+</div>
              <div className="stat-label">Destinations</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">4.8</div>
              <div className="stat-label">Average Rating</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">98%</div>
              <div className="stat-label">Customer Satisfaction</div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="features-cta">
          <h3>Ready to Start Your Adventure?</h3>
          <p>Join thousands of travelers who have discovered amazing destinations with us</p>
          <div className="cta-buttons">
            <button className="btn btn-primary btn-large" onClick={handleSpeakToExpertClick}>Speak to Expert</button>
          </div>
        </div>
      </div>

      {/* Callback Modal */}
      <CallbackModal 
        isOpen={isCallbackModalOpen}
        onClose={() => setIsCallbackModalOpen(false)}
      />
    </section>
  );
};

export default Features;
